import React, { Fragment } from 'react';
import withCopyEdit from '../data-container';
import InfoBox from '../../components/info-box';
const CommunityView = () => {
    return (React.createElement(Fragment, null,
        React.createElement(InfoBox, { type: "warning" }, "This section is under development.")));
};
const CommunityContainer = withCopyEdit(CommunityView);
export default CommunityContainer;
